import { Link } from "react-router-dom"

export default function OnePageNav() {
    return (
        <>
            <ul>
                <li className="has-dropdown active menu-thumb">
                    <Link to="/">
                        Home
                        <i className="fas fa-angle-down ps-1" />
                    </Link>
                    <ul className="submenu has-homemenu">
                        <li>
                            <div className="homemenu-items">
                                <div className="homemenu">
                                    <div className="homemenu-thumb">
                                        <img src="assets/img/header/home-1.jpg" alt="img" />
                                        <div className="demo-button">
                                            <Link to="/" className="theme-btn">
                                                <span>Multi Page</span>
                                            </Link>
                                            <Link to="/index-one-page" className="theme-btn">
                                                <span>One Page</span>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                            Home 01
                                        </h4>
                                    </div>
                                </div>
                                <div className="homemenu">
                                    <div className="homemenu-thumb mb-15">
                                        <img src="assets/img/header/home-2.jpg" alt="img" />
                                        <div className="demo-button">
                                            <Link to="/index-2" className="theme-btn">
                                                <span>Multi Page</span>
                                            </Link>
                                            <Link to="/index-two-page" className="theme-btn">
                                                <span>One Page</span>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                            Home 02
                                        </h4>
                                    </div>
                                </div>
                                <div className="homemenu">
                                    <div className="homemenu-thumb mb-15">
                                        <img src="assets/img/header/home-3.jpg" alt="img" />
                                        <div className="demo-button">
                                            <Link to="/index-3" className="theme-btn">
                                                <span>Multi Page</span>
                                            </Link>
                                            <Link to="/index-three-page" className="theme-btn">
                                                <span>One Page</span>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                            Home 03
                                        </h4>
                                    </div>
                                </div>
                                <div className="homemenu">
                                    <div className="homemenu-thumb mb-15">
                                        <img src="assets/img/header/home-4.jpg" alt="img" />
                                        <div className="demo-button">
                                            <Link to="/index-4" className="theme-btn">
                                                <span>Multi Page</span>
                                            </Link>
                                            <Link to="/index-four-page" className="theme-btn">
                                                <span>One Page</span>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                            Home 04
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <Link to="#about">About</Link>
                </li>
                <li>
                    <Link to="#service">Services</Link>
                </li>
                <li>
                    <Link to="#project">Projects</Link>
                </li>
                <li>
                    <Link to="#team">Team</Link>
                </li>
                <li>
                    <Link to="#blog">Blog</Link>
                </li>
            </ul>

        </>
    )
}
